<template>
	<van-popup v-model="visible" position="bottom" round class="audit-area-picker">
		<div class="audit-area-picker__header">
			<span class="audit-area-picker__btn" @click="visible = false">取消</span>
			<span class="audit-area-picker__title">选择{{ label }}</span>
			<span class="audit-area-picker__btn audit-area-picker__btn--confirm" @click="handleConfirm">确定</span>
		</div>
		<div class="audit-area-picker__tabs" v-if="province">
			<div
				class="audit-area-picker__tab"
				:class="{ 'is-active': tabActive === 0 }"
				@click="tabActive = 0"
			>{{ province.region_name }}</div>
			<div
				class="audit-area-picker__tab"
				v-if="province.children && province.children.length"
				:class="{ 'is-active': tabActive === 1 }"
				@click="tabActive = 1"
			>{{ city ? city.region_name : '请选择' }}</div>
			<div
				class="audit-area-picker__tab"
				v-if="!isProvinceCity && city && city.children && city.children.length"
				:class="{ 'is-active': tabActive === 2 }"
				@click="tabActive = 2"
			>{{ area ? area.region_name : '请选择' }}</div>
		</div>
		<div class="audit-area-picker__list">
			<div
				class="audit-area-picker__item"
				v-for="item in currentList"
				:key="item.id"
				@click="selectItem(item)"
			>{{ item.region_name }}</div>
			<van-empty v-if="!currentList.length" description="暂无数据" />
		</div>
	</van-popup>
</template>

<script>
// 省市区选择弹层（对应小程序 base-area）
export default {
	name: 'AuditAreaPicker',
	props: {
		value: {
			type: Boolean,
			default: false,
		},
		label: {
			type: String,
			default: '地区',
		},
		// province-city：只选到市；否则省/市/区三级
		formatType: {
			type: String,
			default: '',
		},
	},
	data: () => ({
		province: null,
		city: null,
		area: null,
		tabActive: 0,
		list: [],
		loading: false,
	}),
	computed: {
		visible: {
			get() {
				return this.value
			},
			set(val) {
				this.$emit('input', val)
			},
		},
		isProvinceCity() {
			return this.formatType === 'province-city'
		},
		currentList() {
			if (this.tabActive === 1 && this.province) return this.province.children || []
			if (this.tabActive === 2 && this.city) return this.city.children || []
			return this.list
		},
	},
	watch: {
		visible(val) {
			if (val) {
				this.reset()
				this.getRegionTree()
			}
		},
	},
	methods: {
		reset() {
			this.province = null
			this.city = null
			this.area = null
			this.tabActive = 0
		},
		getRegionTree() {
			if (this.list.length) return
			this.loading = true
			this.$api.cpnt
				.getRegionTree()
				.then((res) => {
					this.loading = false
					if (!res.code) this.list = res.data || []
				})
				.catch(() => {
					this.loading = false
				})
		},
		selectItem(item) {
			if (this.tabActive === 0) {
				this.province = item
				this.city = null
				this.area = null
				if (this.isProvinceCity || !(item.children && item.children.length)) {
					this.handleConfirm()
				} else {
					this.tabActive = 1
				}
			} else if (this.tabActive === 1) {
				this.city = item
				this.area = null
				if (this.isProvinceCity || !(item.children && item.children.length)) {
					this.handleConfirm()
				} else {
					this.tabActive = 2
				}
			} else {
				this.area = item
				this.handleConfirm()
			}
		},
		handleConfirm() {
			if (!this.province) return
			this.visible = false
			this.$emit('confirm', {
				province: this.province,
				city: this.city,
				area: this.area,
			})
		},
	},
}
</script>

<style lang="less" scoped>
.audit-area-picker {
	&__header {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 44px;
		padding: 0 16px;
		box-sizing: border-box;
	}

	&__btn {
		font-size: 14px;
		color: #646a73;

		&--confirm {
			color: #1f2329;
		}
	}

	&__title {
		font-size: 15px;
		font-weight: 500;
		color: #1f2329;
	}

	&__tabs {
		display: flex;
		align-items: center;
		border-bottom: 1px solid #f5f6f7;
	}

	&__tab {
		flex: 1;
		height: 40px;
		line-height: 40px;
		text-align: center;
		font-size: 13px;
		color: #646a73;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		&.is-active {
			color: #1f2329;
			font-weight: 500;
			border-bottom: 2px solid var(--color-primary);
		}
	}

	&__list {
		height: 320px;
		overflow-y: auto;
		padding: 0 16px;
		box-sizing: border-box;
	}

	&__item {
		padding: 14px 0;
		font-size: 14px;
		color: #1f2329;
		border-bottom: 1px solid #f5f6f7;
	}
}
</style>
